import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledStatCard = styled.div<{ $multiple: boolean }>`
  display: grid;
  grid-template-columns: ${({ $multiple }) =>
    $multiple
      ? "repeat(auto-fit, minmax(180px, 1fr))"
      : "minmax(180px, max-content)"};
  align-items: center;
  column-gap: ${({ $multiple }) => ($multiple ? "20px" : "0")};
  row-gap: 12px;
  border-radius: ${theme.variables.border_radius_2};
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
`;

export const StyledStatCardItem = styled.div<{ $withDivider?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 0;

  ${({ $withDivider }) =>
    $withDivider &&
    `
    border-left: 1px solid ${theme.colors.grey_5};
    padding-left: 20px;
  `}
`;

export const StyledStatCardIcon = styled.div`
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.purple_2};
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 24px;
    height: 24px;
  }
`;

export const StyledStatCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const StyledStatCardLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
`;
